import React from 'react';

export const FullScreenContext = React.createContext<Partial<FullScreenContextProps>>({});

interface FullScreenContextProps {
  isFull: boolean;
  onChange: (change: boolean) => void
}

interface Props { }

interface State {
  isFull: boolean;
}

export default class FullScreenProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isFull: false,
    };
  }

  onChange = (change: boolean) => {
    this.setState({ isFull: change });
  };

  render() {
    const { children } = this.props;
    const { isFull } = this.state;
    return (
      <FullScreenContext.Provider
        value={{
          isFull,
          onChange: this.onChange,
        }}
      >
        {children}
      </FullScreenContext.Provider>
    );
  }
}

export const FullScreenConsumer = FullScreenContext.Consumer;
